import instance from "../../../../util/axios";
import { Result } from "../../../../schema";
import { Description } from "../../../../component/schema";
import { AxiosResponse } from "axios";

export class DescriptionService {
  static async get(
    tableName: string
  ): Promise<AxiosResponse<Result<Description[]>>> {
    return await instance.get<Result<Description[]>>(
      `/crm/field/description/grid/byTableName/?tableName=${tableName}`
    );
  }
}
